module.exports = __webpack_public_path__ + "static/media/thumb.24bce18a.jpg";